// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1tdvF","header":"ClearentDisclaimer_header__2iJgR","inner":"ClearentDisclaimer_inner__7dc_K"};